import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
const defaultOptions = {} as const;

export type CargoItemsQueryVariables = GraphQLTypes.Exact<{
  zencargoReference: GraphQLTypes.Scalars['String']['input'];
}>;

export type CargoItemsQueryResult = { __typename?: 'Query' } & {
  bookings: { __typename?: 'BookingConnection' } & {
    nodes?: GraphQLTypes.Maybe<
      Array<
        GraphQLTypes.Maybe<
          { __typename?: 'Booking' } & Pick<GraphQLTypes.Booking, 'modeOfTransport' | 'zencargoReference'> & {
              canManageCargo: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
              cargo?: GraphQLTypes.Maybe<
                { __typename?: 'Cargo' } & Pick<GraphQLTypes.Cargo, 'mode'> & {
                    cargoItems?: GraphQLTypes.Maybe<
                      Array<
                        | ({ __typename?: 'CargoContainerType' } & Pick<
                            GraphQLTypes.CargoContainerType,
                            | 'containerNumber'
                            | 'containerSealNumber'
                            | 'containerType'
                            | 'dryStandard'
                            | 'flatRack'
                            | 'garmentsOnHangers'
                            | 'openTop'
                            | 'overweight'
                            | 'palletType'
                            | 'cbm'
                            | 'hazardous'
                            | 'id'
                            | 'looseCargoType'
                            | 'quantity'
                            | 'reefer'
                            | 'type'
                          > & {
                              dimensions?: GraphQLTypes.Maybe<
                                { __typename?: 'CargoDimensionsType' } & Pick<
                                  GraphQLTypes.CargoDimensionsType,
                                  'height' | 'length' | 'metric' | 'width'
                                >
                              >;
                              grossWeight?: GraphQLTypes.Maybe<
                                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
                              >;
                            })
                        | ({ __typename?: 'CargoLooseCargoType' } & Pick<
                            GraphQLTypes.CargoLooseCargoType,
                            | 'containerNumber'
                            | 'palletType'
                            | 'stackable'
                            | 'trailerId'
                            | 'cbm'
                            | 'hazardous'
                            | 'id'
                            | 'looseCargoType'
                            | 'quantity'
                            | 'reefer'
                            | 'type'
                          > & {
                              chargeableWeight?: GraphQLTypes.Maybe<
                                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
                              >;
                              dimensions?: GraphQLTypes.Maybe<
                                { __typename?: 'CargoDimensionsType' } & Pick<
                                  GraphQLTypes.CargoDimensionsType,
                                  'height' | 'length' | 'metric' | 'width'
                                >
                              >;
                              grossWeight?: GraphQLTypes.Maybe<
                                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
                              >;
                            })
                        | ({ __typename?: 'CargoVehicleType' } & Pick<
                            GraphQLTypes.CargoVehicleType,
                            | 'healthCertificate'
                            | 'palletType'
                            | 'riskLevel'
                            | 'tailLift'
                            | 'trailerId'
                            | 'vehicleType'
                            | 'cbm'
                            | 'hazardous'
                            | 'id'
                            | 'looseCargoType'
                            | 'quantity'
                            | 'reefer'
                            | 'type'
                          > & {
                              dimensions?: GraphQLTypes.Maybe<
                                { __typename?: 'CargoDimensionsType' } & Pick<
                                  GraphQLTypes.CargoDimensionsType,
                                  'height' | 'length' | 'metric' | 'width'
                                >
                              >;
                              valueOfGoods?: GraphQLTypes.Maybe<
                                { __typename?: 'Money' } & Pick<GraphQLTypes.Money, 'currency' | 'value'>
                              >;
                              grossWeight?: GraphQLTypes.Maybe<
                                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
                              >;
                            })
                      >
                    >;
                  }
              >;
              coreCargos?: GraphQLTypes.Maybe<
                Array<
                  { __typename?: 'CoreCargo' } & Pick<
                    GraphQLTypes.CoreCargo,
                    | 'cargoType'
                    | 'containerNumber'
                    | 'containerSealNumber'
                    | 'dryStandard'
                    | 'flatRack'
                    | 'garmentsOnHangers'
                    | 'hazardous'
                    | 'healthCertificate'
                    | 'id'
                    | 'openTop'
                    | 'overweight'
                    | 'quantity'
                    | 'refrigerated'
                    | 'riskLevel'
                    | 'stackable'
                    | 'tailLift'
                    | 'trailerId'
                  > & {
                      cargoRelations?: GraphQLTypes.Maybe<
                        Array<
                          { __typename?: 'CargoRelation' } & Pick<GraphQLTypes.CargoRelation, 'startTimestamp'> & {
                              inputCargo?: GraphQLTypes.Maybe<
                                { __typename?: 'CoreCargo' } & Pick<GraphQLTypes.CoreCargo, 'cargoType' | 'id' | 'quantity'>
                              >;
                            }
                        >
                      >;
                      chargeableWeight?: GraphQLTypes.Maybe<
                        { __typename?: 'CargoWeight' } & Pick<GraphQLTypes.CargoWeight, 'unit' | 'value'>
                      >;
                      dimensions?: GraphQLTypes.Maybe<
                        { __typename?: 'Dimensions' } & Pick<GraphQLTypes.Dimensions, 'height' | 'length' | 'unit' | 'width'>
                      >;
                      grossWeight?: GraphQLTypes.Maybe<
                        { __typename?: 'CargoWeight' } & Pick<GraphQLTypes.CargoWeight, 'unit' | 'value'>
                      >;
                      valueOfGoods?: GraphQLTypes.Maybe<
                        { __typename?: 'ValueOfGoods' } & Pick<GraphQLTypes.ValueOfGoods, 'currency' | 'value'>
                      >;
                      volume?: GraphQLTypes.Maybe<{ __typename?: 'Volume' } & Pick<GraphQLTypes.Volume, 'unit' | 'value'>>;
                    }
                >
              >;
            }
        >
      >
    >;
  };
};

export const CargoItemsDocument = /*#__PURE__*/ gql`
  query cargoItems($zencargoReference: String!) {
    bookings(zencargoReferences: [$zencargoReference]) {
      nodes {
        canManageCargo {
          value
        }
        cargo {
          cargoItems {
            cbm
            grossWeight {
              metric
              value
            }
            hazardous
            id
            looseCargoType
            quantity
            reefer
            type
            ... on CargoContainerType {
              containerNumber
              containerSealNumber
              containerType
              dimensions {
                height
                length
                metric
                width
              }
              dryStandard
              flatRack
              garmentsOnHangers
              openTop
              overweight
              palletType
            }
            ... on CargoLooseCargoType {
              chargeableWeight {
                metric
                value
              }
              containerNumber
              dimensions {
                height
                length
                metric
                width
              }
              palletType
              stackable
              trailerId
            }
            ... on CargoVehicleType {
              dimensions {
                height
                length
                metric
                width
              }
              healthCertificate
              palletType
              riskLevel
              tailLift
              trailerId
              valueOfGoods {
                currency
                value
              }
              vehicleType
            }
          }
          mode
        }
        coreCargos {
          cargoRelations {
            inputCargo {
              cargoType
              id
              quantity
            }
            startTimestamp
          }
          cargoType
          chargeableWeight {
            unit
            value
          }
          containerNumber
          containerSealNumber
          dimensions {
            height
            length
            unit
            width
          }
          dryStandard
          flatRack
          garmentsOnHangers
          grossWeight {
            unit
            value
          }
          hazardous
          healthCertificate
          id
          openTop
          overweight
          quantity
          refrigerated
          riskLevel
          stackable
          tailLift
          trailerId
          valueOfGoods {
            currency
            value
          }
          volume {
            unit
            value
          }
        }
        modeOfTransport
        zencargoReference
      }
    }
  }
`;

/**
 * __useCargoItemsQuery__
 *
 * To run a query within a React component, call `useCargoItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCargoItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCargoItemsQuery({
 *   variables: {
 *      zencargoReference: // value for 'zencargoReference'
 *   },
 * });
 */
export function useCargoItemsQuery(baseOptions: Apollo.QueryHookOptions<CargoItemsQueryResult, CargoItemsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<CargoItemsQueryResult, CargoItemsQueryVariables>(CargoItemsDocument, options);
}
export function useCargoItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CargoItemsQueryResult, CargoItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<CargoItemsQueryResult, CargoItemsQueryVariables>(CargoItemsDocument, options);
}
export type CargoItemsQueryHookResult = ReturnType<typeof useCargoItemsQuery>;
export type CargoItemsLazyQueryHookResult = ReturnType<typeof useCargoItemsLazyQuery>;
